




























































































































































import Super from '@/Super';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Sidebar extends Super {
  openISI() {
    this.openPDF('Important Safety Information', './pdfs/isi.pdf');
  }

  openPI(event: MouseEvent) {
    event.preventDefault();
    this.openPDF('Prescribing Information', './pdfs/pi.pdf');
  }
}
